import SavedAudienceSourcesPage from '../pages/dashboard/components/pages/audienceSources/SavedAudienceSourcesPage';
export default function AudienceSourcesRoute() { return <SavedAudienceSourcesPage />; }
